import * as XLSX from 'xlsx'

/**
 * Export an array of plain-object rows to an .xlsx file.
 *
 * @param {Array<Object>} rows    Raw API rows (report items).
 * @param {Array<{key: string, label: string, format?: (value, row) => any}>} columns
 *   `key` supports dot-paths (e.g. "patient.FullName"). `label` becomes the
 *   spreadsheet header. `format`, if given, transforms the raw value —
 *   otherwise the raw value is used as-is.
 * @param {string} filename       e.g. "consultation-reports-all-2026-09-10.xlsx"
 */
export function exportRowsToExcel(rows, columns, filename) {
  const data = rows.map((row) => {
    const record = {}
    columns.forEach(({ key, label, format }) => {
      const raw = key.split('.').reduce((obj, k) => (obj == null ? obj : obj[k]), row)
      record[label] = format ? format(raw, row) : (raw ?? '')
    })
    return record
  })

  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Report')
  XLSX.writeFile(workbook, filename)
}

/** Today's date as YYYY-MM-DD, for building export filenames. */
export function todayStamp() {
  return new Date().toISOString().slice(0, 10)
}
